import React from "react";
import {Box, Typography} from "@mui/material";

const InfoRow = ({label, value}) => (
    <Box sx={{display: "flex", flexDirection: "column", gap: 0.25}}>
        <Typography variant="caption" sx={{opacity: 0.8}}>{label}</Typography>
        <Typography>{value ?? "-"}</Typography>
    </Box>
);

export default InfoRow;
